import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRentbuy = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m32 13.625-3.768-3.821v-5.73h-2.513v3.185l-3.768-3.82-8.066 8.593 6.81 6.755v-1.98h2.512v3.821h6.28V14.26H32zm-11.901 7.933-10.05-10.186L0 21.558v.638h2.512v6.366h6.281V24.74h2.513v3.82h6.28v-6.365H20.1z" /></svg>;
export default SvgRentbuy;